import { useEffect, useRef } from "react";
import { INPUT_TEXT, INPUT_TEXT_AREA } from "./GstaInput.constants";
import "./GstaInput.style.scss";

const GstaInput = ({
  label,
  id,
  value,
  setValue,
  isValid,
  placeholder,
  dataTestId,
  Icon,
  errorMessage,
  scrollTarget,
  appearanceClass,
  formatValue,
  type,
  autoFocus,
  clearable,
  debounce = 800,
}) => {
  const timeoutRef = useRef(null);
  const inputRef = useRef(null);

  const handleChange = (event) => {
    const rawValue = event.target.value;
    const newValue = formatValue ? formatValue(rawValue) : rawValue;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setValue(newValue);
    }, debounce);
  };

  const resetValue = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setValue("");
  };

  const focusInput = () => {
    inputRef.current?.focus();
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (scrollTarget && scrollTarget?.id === id && inputRef.current?.scrollIntoView) {
      inputRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [scrollTarget, id]);

  const commonProps = {
    id,
    value: value ?? "",
    onChange: handleChange,
    placeholder,
    "data-testid": dataTestId,
    autoFocus,
    autoComplete: "off",
    onBlur: (e) => setValue(e.target.value),
    onKeyDown: (e) => {
      if (e.key === "Enter") setValue(e.target.value);
    },
    ref: inputRef,
  };

  return (
    <section className={`gsta-input ${appearanceClass ?? ""}`}>
      <div>
        {label && (
          <label htmlFor={id}>
            <b>{label}</b>
          </label>
        )}

        <article>
          {type === INPUT_TEXT && (
            <input
              type="text"
              {...commonProps}
            />
          )}

          {type === INPUT_TEXT_AREA && <textarea {...commonProps} />}

          {clearable && value?.length > 0 ? (
            <i
              className="icon-close"
              onClick={resetValue}
            />
          ) : Icon ? (
            <i
              className={Icon}
              onClick={focusInput}
            />
          ) : null}
        </article>
      </div>

      {errorMessage && <span className="full-width gsta-input-error-message">{!isValid ? errorMessage : " "}</span>}
    </section>
  );
};

export default GstaInput;
